import consumer from "./consumer";
import sweet_alert from "../utilities/sweet_alert";

class CombineBankBillsChannel {
  static init() {
    return consumer.subscriptions.create({channel: "CombineBankBillsChannel", user_email: Traus.company.user.email}, {
      received: (data) => {
        if (!data || !data.status)
          return;

        if (data.status === 'success') {
          this.combineTuitionsSuccess(data);
        } else {
          this.combineTuitionsFailure(data);
        }
      },

      close() {
        // Unsubscribe only this subscription; the shared consumer's WebSocket
        // stays alive for the other channels multiplexed over it.
        this.unsubscribe();
      },
    });
  }

  static combineTuitionsSuccess(data) {
    sweet_alert.fire({
      title: 'Pronto',
      icon: 'success',
      text: `Carnê de Boletos do aluno ${data.student_name}, foi anexado com sucesso. Deseja ser redirecionado para a matrícula?`,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Ver Matrícula',
      cancelButtonText: 'Fechar'
    }).then((result) => {
      if (result.value) {
        window.location.href = data.redirect_to;
      }
    });
  }

  static combineTuitionsFailure(data) {
    sweet_alert.fire({
      title: 'Atenção',
      icon: 'error',
      text: data.message,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCancelButton: true,
      focusConfirm: true,
      confirmButtonText: 'Ver Matrícula',
      cancelButtonText: 'Fechar'
    }).then((result) => {
      if (result.value) {
        window.location.href = data.redirect_to;
      }
    });
  }
}

$(() => CombineBankBillsChannel.init());